/**
 * @ngdoc services
 * @memberof mercury.services
 * @name title
 */
angular.module('mercury.services.title')
.factory('title', ["$document", "$rootScope", function($document, $rootScope) {
  /**
   * The current page title.
   *
   * @memberof title
   */
  var title = '';

  var subheader = '';

  var locked = false;

  /**
   * Update the current page title and broadcast the change on the rootScope
   *
   * @memberof title
   */
  function set(newTitle) {
    if (locked) {
      return;
    }

    this.title = newTitle;
    this.subheader = '';

    if (newTitle) {
      $document.prop('title', 'Loaded - ' + newTitle);
    } else {
      $document.prop('title', 'Loaded');
    }

    $rootScope.$broadcast('titleChange');
  }

  /**
   * Update the current page title and broadcast the change on the rootScope
   *
   * @memberof title
   */
  function setSubheader(newTitle) {
    if (locked) {
      return;
    }

    this.subheader = newTitle;
    $rootScope.$broadcast('titleChange');
  }

  function lock() {
    locked = true;
  }

  function unlock() {
    locked = false;
  }

  return {
    title: title,
    set: set,
    subheader: subheader,
    setSubheader: setSubheader,
    lock: lock,
    unlock: unlock
  };
}]);
